
import { Link } from "react-router-dom";

function NotFound() {
  return (
   <main id="main">

  <div className="page-header">
    <svg viewBox="0 0 100 100" className="page-header__seal" aria-hidden="true" style={{color:'#fff'}}>
      <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" strokeWidth="0.8"/>
      <path id="sealTopB" d="M 14,50 A 36,36 0 1,1 86,50" fill="none"/>
      <text fontSize="5.4" letterSpacing="1.5" fill="currentColor"><textPath href="#sealTopB" startOffset="50%" textAnchor="middle">JUSTICE FOR ALL</textPath></text>
    </svg>
    <div className="container">
      <div className="breadcrumb"><Link to='/'>Home</Link> / Page Not Found (404)</div>
      <h1>Oops! The page you were looking for dosen't exist</h1>
      <p>You may have misstyped the address or the page may have moved.</p>
    </div>
  </div>

  

  <section className="section section--alt">
    <div className="container">
      <div className="section__head">
        <div><span className="eyebrow">No Record Found</span><h2>Page Not Found (404)</h2></div>
      </div>
      <Link to="/" className="btn btn--outline-navy btn--sm">Return Home</Link>
    </div>
  </section>

</main>
  );
}

export default NotFound;
